/** Shared design tokens for card components. */

export const CARD_MAX_WIDTH = 768;
export const CARD_MAX_WIDTH_DESKTOP = "100%";
export const CARD_BORDER_RADIUS = 3;
export const CARD_CONTENT_SPACING = 2;
export const CARD_ELEVATION = 3;

/** Full-width route cards: capped on phones, fluid on md+, capped again on xl+. */
export const SCREEN_CARD_WIDTH_SX = {
    width: "100%",
    maxWidth: { xs: CARD_MAX_WIDTH, md: "100%", xl: CARD_MAX_WIDTH_DESKTOP },
    mx: "auto",
} as const;
